const tabNavigation = $('[data-bs-toggle="tab"]');

if (tabNavigation.length) {
  const hash = window.location.hash;
  const tabPane = $(hash);

  if (hash.length && tabPane.length && !tabPane.hasClass('js-ignore-tab-link')) {
    // Prevent scrolling on load page
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);

    const tab = $('a[href="' + hash + '"]');
    tab.tab('show');
  }

  tabNavigation.on('click', function (e) {
    e.preventDefault();
    const hash = e.currentTarget.hash;

    const tabPane = $(hash);
    $(this).tab('show');


    if (tabPane.hasClass('js-ignore-tab-link')) {
      return;
    }



    // Remove the id temporary to prevent it from scrolling.
    tabPane.prop('id', '')

    window.location.hash = hash;

    // Put the id back.
    tabPane.prop('id', hash.replace('#', ''));
  });
}
